import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'LICITACAO'
})
export class LicitacaoPipe implements PipeTransform {
    transform(value: string, ...args: any[]): any {
        if (!value) {
            return '';
        }

        value = value.split('.').join('')
            .split(',').join('')
            .split(':').join('')
            .split(';').join('')
            .split('/').join('')
            .split('-').join('');

        if (value.length === 8) {
            return value.replace(/(\d{4})(\d{4})/g, '\$1\/\$2');
        } else if (value.length === 9) {
            return value.replace(/(\d{5})(\d{4})/g, '\$1\/\$2');
        } else {
            return value;
        }
    }
}
